module.exports = __webpack_public_path__ + "static/img/login_logo.f3d3433.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/login_logo.svg
// module id = 0I1N
// module chunks = 1